import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import Redbox from 'redbox-react'
import createHistory from 'history/createBrowserHistory'

import './styles/styles.scss'
import Root from './components/root'
import { initAuth } from './modules/auth'
import configureStore from './store'


const history = createHistory()
const store = configureStore(history)

function render(Root) {
  ReactDOM.render(
    <AppContainer errorReporter={Redbox}>
      <Root
        history={history}
        store={store}
      />
    </AppContainer>,
    document.querySelector('.app-root')
  )
}

if (module.hot) {
  module.hot.accept('./components/root', () => {
    render(require('./components/root').default)
  })
}

initAuth(store.dispatch)
  .then(() => render(Root))
  .catch(error => console.error(error)) // eslint-disable-line no-console



// WEBPACK FOOTER //
// ./src/main.js